export default "__VITE_ASSET__BEpnrIjl__"